module.exports = __webpack_public_path__ + "img/159131706908.317edeee.png";